import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('howie_geography', '/howie_geographies')
const reducer = generator.generate()

export default reducer
